document.querySelectorAll('[data-av-more-to-love]').forEach((feed) => {
  const grid = feed.querySelector('.av-more-to-love__grid');
  const sentinel = feed.querySelector('.av-more-to-love__sentinel');
  const button = feed.querySelector('.av-more-to-love__button');
  const skeletons = feed.querySelector('.av-more-to-love__skeletons');
  const cacheKey = `av-feed-collection-section-${window.Shopify?.theme?.id || ''}`;
  let sectionId = null;
  try { sectionId = localStorage.getItem(cacheKey); } catch (error) {}
  const pageSize = Number(feed.dataset.pageSize) || 24;
  const sources = [feed.dataset.source || 'all'];
  let sourceIndex = 0;
  let page = 1;
  let autoPages = 0;
  let busy = false;
  let stopped = false;
  let failed = false;
  const shown = new Set([...document.querySelectorAll('[data-product-id]')].map((el) => el.dataset.productId));

  async function load(manual = false) {
    if (busy || stopped) return;
    busy = true;
    button.hidden = true;
    skeletons.hidden = false;
    try {
      const handle = sources[sourceIndex];
      const query = sectionId ? `section_id=${encodeURIComponent(sectionId)}&page=${page}` : `page=${page}`;
      const response = await fetch(`/collections/${encodeURIComponent(handle)}?${query}`, { credentials: 'same-origin' });
      if (!response.ok) {
        // A cached section id goes stale if the template changes; forget it and refetch the full page.
        if (sectionId && response.status === 404) { sectionId = null; try { localStorage.removeItem(cacheKey); } catch (error) {} }
        throw new Error(`HTTP ${response.status}`);
      }
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      if (!sectionId) {
        sectionId = parsed.querySelector('[id^="shopify-section-"][id$="__main"]')?.id.replace('shopify-section-', '') || null;
        try { if (sectionId) localStorage.setItem(cacheKey, sectionId); } catch (error) {}
      }
      const cards = [...parsed.querySelectorAll('#ResultsList li[data-product-id]')];
      if (!cards.length) {
        stopped = true;
        window.AvFeedMix?.start({ grid, seed: feed.dataset.productId, category: feed.dataset.source, productPage: true, pageSize, initialAutoPages: autoPages });
        return;
      }
      cards.forEach((card) => {
        const id = card.dataset.productId;
        if (!id || shown.has(id)) return;
        shown.add(id);
        card.querySelectorAll('img[loading="eager"]').forEach((img) => img.loading = 'lazy');
        grid.append(card);
      });
      if (!manual) autoPages++;
      page++;
      if (cards.length < pageSize) {
        stopped = true;
        window.AvFeedMix?.start({ grid, seed: feed.dataset.productId, category: feed.dataset.source, productPage: true, pageSize, initialAutoPages: autoPages });
      }
      failed = false;
    } catch (error) {
      failed = true;
    } finally {
      busy = false;
      skeletons.hidden = true;
      if (!stopped) button.hidden = !(failed || autoPages >= 3);
      // The observer only reports changes; if the sentinel is still in range
      // after this page landed, re-observe so the next page loads too.
      if (!stopped && !failed && autoPages < 3) { observer.unobserve(sentinel); observer.observe(sentinel); }
    }
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting) && !button.hidden) return;
    if (entries.some((entry) => entry.isIntersecting) && autoPages < 3 && !stopped) load();
  }, { rootMargin: '800px 0px' });
  observer.observe(sentinel);
  button.addEventListener('click', () => { failed = false; load(true); });
});
